import { Switch } from 'antd';
import { WarningOutlined } from '@ant-design/icons';

import { useT } from '../../../../i18n';
import { soVN } from '../../../../lib/dinh-dang';
import { CHE_DO_TRA_LOI } from '../../constants-bot';
import { TRAN_NGUON } from '../../types';
import { ChonNhieuNguon } from './ChonNhieuNguon';
import { Khoi, NutLuaChon, ODanhSachDong, type LuaChon, type TabProps } from './chung';

export function TabTriThuc({
  f, dat, suaDuoc, boTriThuc, nguonDuLieu,
}: TabProps & { boTriThuc: LuaChon[]; nguonDuLieu: LuaChon[] }) {
  const { t, locale } = useT();
  const khongNguon = !f.knowledgeBaseIds.length && !f.sourceIds.length;
  const bat = (k: 'knowledgeBaseIds' | 'sourceIds', id: string) =>
    dat(k, f[k].includes(id) ? f[k].filter((x) => x !== id) : [...f[k], id]);

  return (
    <div className="space-y-4">
      <Khoi ten={t('troLyAiBot.mucNguon')} mo={t('troLyAiBot.mucNguonMo')}>
        {khongNguon ? (
          <p className="flex items-start gap-1.5 text-xs leading-relaxed text-warning-700">
            <WarningOutlined className="mt-px shrink-0 text-xs" />
            {f.mode === 'knowledge_only' ? t('troLyAiBot.khongNguonKO') : t('troLyAiBot.khongNguonMo')}
          </p>
        ) : null}

        <div className="grid gap-4 sm:grid-cols-2">
          <ChonNhieuNguon
            nhan={t('troLyAiBot.boTriThuc')}
            ds={boTriThuc}
            chon={f.knowledgeBaseIds}
            onBat={(id) => bat('knowledgeBaseIds', id)}
            suaDuoc={suaDuoc}
            rong={t('troLyAiBot.chuaCoBo')}
          />

          <div className="min-w-0">
            {/*
              Nhiều nguồn được: mỗi nguồn là một CSDL riêng nên một câu SQL không chạm được hai nguồn — một lượt hỏi chạy
              MỘT CÂU SQL RIÊNG trên TỪNG nguồn đã tích, và câu trả lời ghi rõ con số nào của nguồn nào. Tích thêm nguồn là
              thêm một lượt chạy cho MỖI câu hỏi, nên có trần.
            */}
            <ChonNhieuNguon
              nhan={t('troLyAiBot.nguonSoLieu')}
              ghiChu={t('troLyAiBot.chonNhieu')}
              ds={nguonDuLieu}
              chon={f.sourceIds}
              onBat={(id) => bat('sourceIds', id)}
              suaDuoc={suaDuoc}
              tran={TRAN_NGUON}
              chuaSanSang={(s) => s.phu === 'draft' || s.phu === 'error'}
              rong={t('troLyAiBot.chuaCoNguon')}
            />
            {f.sourceIds.length >= TRAN_NGUON ? (
              <p className="mt-1.5 text-xs text-content-muted">
                {t('troLyAiBot.tranNguon', { n: soVN(TRAN_NGUON, locale) })}
              </p>
            ) : null}
          </div>
        </div>

        {/*
          Nguồn THỨ BA, và là nguồn CUỐI: tra web khi bản sao và kho tri thức không có gì. Đặt trong mục Nguồn chứ không
          cạnh "Tên miền được phép nhúng" — một cái là hàng rào bảo mật, một cái là quyền đọc.
        */}
        <div className="mt-4">
          <p className="mb-1 text-xs font-medium text-content-secondary">
            {t('troLyAiBot.traWeb')}
            {!f.webDomains.length ? (
              <span className="ms-2 font-normal text-content-muted">{t('troLyAiBot.traWebRong')}</span>
            ) : null}
          </p>
          <p className="mb-1.5 text-xs leading-relaxed text-content-muted">{t('troLyAiBot.traWebMo')}</p>
          <ODanhSachDong
            autoSize={{ minRows: 2, maxRows: 6 }}
            disabled={!suaDuoc}
            aria-label={t('troLyAiBot.traWeb')}
            placeholder={t('troLyAiBot.traWebViDu')}
            giaTri={f.webDomains}
            onDoi={(ds) => dat('webDomains', ds)}
          />
          <p className="mt-1 text-xs text-content-muted">{t('troLyAiBot.traWebGhi')}</p>
          <p className="mt-1 text-xs leading-relaxed text-content-muted">{t('troLyAiBot.traWebKhacGoc')}</p>
        </div>
      </Khoi>

      <Khoi ten={t('troLyAiBot.mucCachTraLoi')}>
        <div>
          <p className="mb-1.5 text-xs font-medium text-content-secondary">{t('troLyAiBot.phamViTraLoi')}</p>
          <div className="grid gap-2 sm:grid-cols-2">
            {CHE_DO_TRA_LOI.map((m) => (
              <NutLuaChon
                key={m.ma}
                chon={f.mode === m.ma}
                tat={!suaDuoc}
                nhan={t(m.nhan)}
                mo={t(m.mo)}
                onChon={() => dat('mode', m.ma)}
              />
            ))}
          </div>
        </div>

        <div>
          <label className="flex items-center gap-2 text-xs">
            <Switch size="small" checked={f.trichNguon} disabled={!suaDuoc} onChange={(v) => dat('trichNguon', v)} />
            {t('troLyAiBot.trichNguon')}
          </label>
          <p className="mt-1 text-xs text-content-muted">{t('troLyAiBot.trichNguonMo')}</p>
        </div>
      </Khoi>
    </div>
  );
}
